export default __webpack_public_path__ + "static/media/background_empresa.5902d9b9.jpg";